import Log from './log';

export function trackPodsights(event: string, data: Record<string, string> = {}): void {
	try {
		window.pdst(event, data);
	} catch (e) {
		Log.scope('Podsights').exception(e, { event, data });
	}
}
